module.exports = __webpack_public_path__ + "img/7effe17.jpg";